module.exports = __webpack_public_path__ + "img/bg@2x.a46d5d87.png";